import type { ColumnsType } from "antd/es/table";
import { Card } from "@rumbledirect/ui";
import { Table } from "@/components/v2";

interface TableDataItem {
  label: string;
  value: number;
}

interface AntdTableChartProps {
  title: string;
  data: TableDataItem[];
  className?: string;
}

export const AntdTableChart = ({
  title,
  data,
  className,
}: AntdTableChartProps) => {
  const columns: ColumnsType<TableDataItem> = [
    {
      title: "Item",
      dataIndex: "label",
      key: "label",
    },
    {
      title: "Aantal",
      dataIndex: "value",
      key: "value",
      align: "right",
      render: (value: number) => value?.toLocaleString() || 0,
    },
  ];

  const filteredData = data.filter(
    (item) => item.value !== null && item.value !== undefined,
  );

  return (
    <Card className={className} title={title}>
      <Table
        columns={columns}
        dataSource={filteredData.map((item, index) => ({
          ...item,
          key: index,
        }))}
        pagination={false}
        size="small"
        showHeader={false}
        style={{ minHeight: "250px" }}
      />
    </Card>
  );
};
